import React, { useEffect, useState } from "react";
import { Image, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { get_pending_exp_activity } from "../../../../../store/actions/Experience/adminExperienceAction";
import BasicPagination from "../../../../Pagination/Pagination";
import { IconBoxReusableSeatingComponent } from "../../../../reusableComponents/IconBoxReusable/IconBoxReusableComponent";
import NoContent from "../../../../reusableComponents/NoContentComponent";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { RightSideCountTop } from "../../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import TableBody from "../TableBody";
import TableSizePopup from "../../../../reusableComponents/allPopupReusable/tableNumberPopup/TableSizePopup";
import ExpFilterSection from "../../../../vendorDashboardComponents/Experiences/Experiencedashboard/ExpFilterSection";
import { successAlert } from "../../../../../function/alert";
import { amApi } from "../../../../../api/apiHelper";

const pendingWhite = require("../../../../../assets/images/seatingImages/pendingexp.png");

const SuperAdminSeatingPendingExperienceReport = () => {
  const [experiences, setExperiences] = useState([]);
  const [search, setSearch] = useState("");
  const [expStatus,setexpstatus]=useState('');
  const [filterseatingvalue, setseatingstatusValue] = useState("");
  const [filterpaxvalue, setSeatingPaxvalue] = useState("");
  const [SeatingPaymetType,setSeatingPaymetType]=useState("");
  const [SeatingPaymetStatus,setSeatingPaymetStatus]=useState("");
  const [state, setState] = useState({
    search: "",
    restaurant_type: "",
    request_type: "All",
    restaurantReverse: "",
    openPax: false,
    showPax: "All",
    showPaxText: "",
    showSearch: false,
  });

  const auth = useSelector((state) => state.auth);

  const getData = async (e) => {
    let _d = await get_pending_exp_activity(auth?.user?.accessToken, "PENDING");
    setExperiences(_d);
  };

  useEffect(() => {
    getData();
  }, []);

  // Pagination
  const [pagination, setPagination] = useState({
    page: 1,
    start: 0,
    end: 10,
  });
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setPagination({
      ...pagination,
      start: calcStart,
      end: pageNo * 10,
      page: pageNo,
    });
  };

  /*********************************
   * @DESC Show Pax Modal Action
   *********************************/
  const onOpenModalPax = (e) => {
    setState({
      ...state,
      openPax: true,
    });
  };
  const onCloseModalPax = (e) => {
    setState({
      ...state,
      openPax: false,
    });
  };
  const bigButtonShowPaxHandler = (e, type) => {
    e.preventDefault();
    setState({
      ...state,
      showPaxText: type,
    });
  };
  const selectPaxClick = (e) => {
    setState({
      ...state,
      showPax: state.showPaxText === "" ? "All" : state.showPaxText,
      openPax: false,
    });
  };

  ///////////////////////
  // search and filters //
  ////////////////////////

  let filtereddata = experiences;
  if (search) {
    let searchData = new RegExp(search, "i");
    filtereddata = experiences.filter((getall) => {
      if (searchData.test(getall?.userDetails?.name)) {
        return getall;
      } else if (searchData.test(getall?.requestId)) {
        return getall;
      } else {
        return false;
      }
    });
  }
  
  if (filterpaxvalue === "All" && filterseatingvalue === "All") {
    filtereddata = experiences;
  } else if (filterpaxvalue === "8>") {
    filtereddata = experiences.filter(
      (dinner) => dinner.adultCount + dinner.kidsCount >= 8
    );
  } else if (filterpaxvalue === "8") {
    filtereddata = experiences.filter((dinner) => {
      if (
        dinner.adultCount + dinner.kidsCount >= 7 &&
        dinner.adultCount + dinner.kidsCount <= 8
      ) {
        return dinner;
      } else {
        return false;
      }
    });
  } else if (filterpaxvalue === "6") {
    filtereddata = experiences.filter((dinner) => {
      if (
        dinner.adultCount + dinner.kidsCount >= 5 &&
        dinner.adultCount + dinner.kidsCount <= 6
      ) {
        return dinner;
      } else {
        return false;
      }
    });
  } else if (filterpaxvalue === "4") {
    filtereddata = experiences.filter((dinner) => {
      if (
        dinner.adultCount + dinner.kidsCount >= 3 &&
        dinner.adultCount + dinner.kidsCount <= 4
      ) {
        return dinner;
      } else {
        return false;
      }
    });
  } else if (filterpaxvalue === "2") {
    filtereddata = experiences.filter((dinner) => {
      if (
        dinner.adultCount + dinner.kidsCount >= 0 &&
        dinner.adultCount + dinner.kidsCount <= 2
      ) {
        return dinner;
      } else {
        return false;
      }
    });
  }
  if (filterseatingvalue === "Not Seated") {
    filtereddata = experiences.filter(
      (dinner) => dinner.status === "NOTSEATED"
    );
  }
  if (filterseatingvalue === "Seated") {
    filtereddata = experiences.filter((dinner) => dinner.status === "SEATED");
  }
  if (SeatingPaymetType) {
    if(SeatingPaymetType === 10){
      filtereddata=experiences;
    }else if(SeatingPaymetType === 11) {
      filtereddata = experiences.filter(
        (dinner) => dinner.splitPayment === true
      );
    }else {
    filtereddata = experiences.filter(
      (dinner) => dinner.paymentData?.paymentMethod === SeatingPaymetType
    );
  }
}
  if (SeatingPaymetStatus !== "") {
    if(SeatingPaymetStatus === 10){
      filtereddata = experiences;
    }else
    filtereddata = filtereddata.filter(
      (dinner) => dinner?.paymentStatus === SeatingPaymetStatus
    );
  }
  if(expStatus){
    if(expStatus === "All"){
      filtereddata=experiences;
    }else
    filtereddata=experiences.filter((e) => e.status === expStatus)
  }

 
  const onStatusChange = async (type, formData, id) => {
    let patch = await amApi.patch(`/expRequest/${id}`, formData);
    let data = [...experiences]
    data = data.filter(ele => ele._id.toString() !== patch?.data?._id.toString());
    setExperiences(data);
    successAlert("Updated Successfully");
  }
  
  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="Reports" />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Pending Experience Activity Report
                </div>
              </div>
              <div className="d-flex justify-content-between mt-3 mb-3">
                <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 seating-left-side-navigation">
                  <div className="row">
                    <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 text-center">
                      <IconBoxReusableSeatingComponent
                        classSection={
                          "newseating-dashboard-reusable-button newseating-dashboard-reusable-button-active"
                        }
                        // imageStyle="inside-image-button"
                        src={pendingWhite}
                        iconText="Pending"
                        iconTextStyle={
                          "icon-bottom-text icon-bottom-text-active"
                        }
                        link="#"
                        bedgeClass="badge custom-icon-button-badge custom-badge-position-pending"
                        // displayNotification={true}
                        // notificationCount={props.getAllVendorList.length}
                        bottomLine={"bottom-box-line"}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-8">
                  <div className="row">
                    <div className="col-6"></div>
                    <div className="col-6 d-flex justify-content-end">
                      <RightSideCountTop
                        content={[
                          {
                            name: "Pending requests",
                            value: experiences?.length || "0",
                            backgroundColor: "#FFEDE9",
                            color: "#EE3A23",
                          },
                          // {
                          //   name: "Ticket Booking Requests",
                          //   value: 40,
                          //   backgroundColor: "#D8F3F4",
                          //   color: "#138B90",
                          // },
                        ]}
                      />
                    </div>
                  </div>
                </div>
              </div>{" "}
              <hr />
              <ExpFilterSection
                  showdownloadBtn={true}
                  searchvalue={(e) => setSearch(e)}
                  expstatus={(e)=> setexpstatus(e)}
                  seatingpaymenttype={(e) => {setSeatingPaymetType(e)}}
                  seatingpaymentStatus={(e) => {setSeatingPaymetStatus(e)}}
                  seatingstatusValue={(e) => setseatingstatusValue(e)}
                  seatingpaxvalue={(e) => setSeatingPaxvalue(e)}
                />
              <div>
                <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-maine">
                  <Table className="HideShowTable enMinWidth900">
                    <thead>
                      <tr className="super_admin_all_users_table_head">
                        <td style={{ width: "20%" }} className="f12-400">
                          Business Name <br />
                          /Location/ID
                        </td>
                        <td style={{ width: "15%" }} className="f12-400">
                          Name / <br />
                          Request Number
                        </td>
                        <td style={{ width: "15%" }} className="f12-400">
                          Total PAX
                        </td>
                        <td
                          style={{ width: "10%" }}
                          className="f12-400 d-flex align-items-center"
                        >
                          <div>
                            <p className="font_16_r">Date / Time</p>
                            <p className="font_16_r">Timer</p>
                            <p className="font_10_r">(HH:MM:SS)</p>
                          </div>
                          <div
                            className="ml-2"
                            style={{ cursor: "pointer" }}
                            //  onClick={() => (sortByDateTime ? sortByDateTime() : {})}
                          >
                            <Image
                              alt="Sort"
                              title="Sort"
                              width="20px"
                              src={require("../../../../../assets/images/iconButton/ntimer.png")}
                            />
                          </div>
                        </td>
                        <td
                          style={{ width: "20%" }}
                          className="f12-400 text-center"
                        >
                          Payment <br />
                          Status
                        </td>
                        <td style={{ width: "8%" }} className="f12-400">
                          Seating <br />
                          Preference
                        </td>
                        <td style={{ width: "8%" }} className="f12-400">
                          Status
                        </td>
                        <td style={{ width: "14%" }} className="f12-400">
                          Actions
                        </td>
                      </tr>
                    </thead>
                    {filtereddata?.length ? (
                      <React.Fragment>
                        {filtereddata
                          .slice(pagination?.start, pagination?.end)
                          .map((e) => {
                            return <TableBody data={e} key={e?._id} onStatusChange={onStatusChange} />;
                          })}

                        <BasicPagination
                          totalRecords={filtereddata?.length || 0}
                          limit={10}
                          batch={pagination?.page}
                          onBatchChange={(e) => handleBatchChange(e)}
                        />
                      </React.Fragment>
                    ) : (
                      <NoContent />
                    )}
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminSeatingPendingExperienceReport;
